import axios, { CancelTokenSource } from 'axios';
import { useRef } from 'react';

class CancellableRequest {
  private _token: CancelTokenSource;

  constructor() {
    this._token = axios.CancelToken.source();
  }

  public get cancelToken() {
    return this._token.token;
  }

  cancel() {
    this._token.cancel();
  }
}

export default function useCancelToken() {
  const requests = useRef<CancellableRequest[]>([]).current;

  const issueToken = () => {
    requests[0]?.cancel();

    const request = new CancellableRequest();
    requests.push(request);

    return request.cancelToken;
  };

  const discardToken = () => {
    requests.shift();
  };

  return { issueToken, discardToken };
}
